import styled from 'styled-components'

/**
 * Create a Fixed Placement item in the Main Area
 * [1]: Force Fixed Placements to stay within certain sizes when sticky
 * [2]: This also reduces the issue, for most cases, of the sticky element covering the scrollbar
 * [3]: Mid point of main area is (100% - (sideFrameSizeAtBreakpointX + averageScrollbarWidth)) / 2
 * [4]: For cases where our ads are bigger than we expect, just hide the excess
 * [5]: Make the placement more visible for users as the Ad is loading to prevent accidental clicks
 */
export const FixedPlacement = styled.div`
  max-width: 800px; /* [1], [2] */
  max-height: 110px; /* [1], [2] */

  left: calc(50% - 208.5px); /* [3] */

  overflow: hidden; /* [4] */

  background-color: ${({ theme }) =>
    theme.Colors.forInterface.interfaceColor12}; /* [5] */
  border: 1px solid #ccc; /* [5] */
`
